module.exports = __webpack_public_path__ + "media/site_templates/www.pavingcontractors.com.au/images/our_services_2-7b8d3c4c40753d7811f8ea831b4c7f88.jpg";